import { render, staticRenderFns } from "./ItemFilterInterestLayout.vue?vue&type=template&id=dc56349c&scoped=true&"
import script from "./ItemFilterInterestLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterInterestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc56349c",
  null
  
)

export default component.exports